export default "__VITE_ASSET__Bf10T2RP__"